// Theme: nyc-rebel
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'nyc-rebel',
  name: 'NYC REBEL',
  tagline: 'NYC REBEL',
  description: 'Grafite neutro de asfalto e concreto em versao free BP leve.',
  category: 'urban-expression',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#101311', '#191D1A', '#84CC16', '#E5F6C8'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '14px',
      '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
      '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)'
    },
    shellClasses: 'font-mono theme-nyc-rebel'
  },
  colorVars: {
    '--accent': '#84CC16',
    '--accent-foreground': '#101311',
    '--background': '#101311',
    '--border': '#243024',
    '--card': '#191D1A',
    '--card-border-active': 'rgba(132, 204, 22, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E5F6C8',
    '--card-glow': 'rgba(132, 204, 22, 0.03)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#101311',
    '--foreground': '#E5F6C8',
    '--hold-fill': '#84CC16',
    '--input': '#243024',
    '--modal-bg': '#101311',
    '--modal-border': '#243024',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#243024',
    '--muted-foreground': '#D9EAC2',
    '--nav-active': '#84CC16',
    '--nav-bg': '#191D1A',
    '--popover': '#191D1A',
    '--popover-foreground': '#E5F6C8',
    '--primary': '#84CC16',
    '--primary-foreground': '#101311',
    '--ring': '#84CC16',
    '--secondary': '#2D3C2A',
    '--secondary-foreground': '#E5F6C8',
    '--streak': '#84CC16',
    '--success': '#22c55e',
    '--success-foreground': '#101311',
    '--xp': '#84CC16',
    '--xp-bg': '#191D1A'
  },
  resolvedVars: {
    '--accent': '#84CC16',
    '--accent-foreground': '#101311',
    '--accent-foreground-hsl': '140 9% 7%',
    '--accent-foreground-oklch': 'from #101311 l c h',
    '--accent-hsl': '84 81% 44%',
    '--accent-oklch': 'from #84CC16 l c h',
    '--background': '#101311',
    '--background-hsl': '140 9% 7%',
    '--background-oklch': 'from #101311 l c h',
    '--border': '#243024',
    '--border-hsl': '120 14% 16%',
    '--border-oklch': 'from #243024 l c h',
    '--border-w': '1px',
    '--card': '#191D1A',
    '--card-border-active': 'rgba(132, 204, 22, 0.10)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#E5F6C8',
    '--card-foreground-hsl': '82 72% 87%',
    '--card-foreground-oklch': 'from #E5F6C8 l c h',
    '--card-glow': 'rgba(132, 204, 22, 0.03)',
    '--card-hsl': '135 7% 11%',
    '--card-oklch': 'from #191D1A l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#101311',
    '--destructive-foreground-hsl': '140 9% 7%',
    '--destructive-foreground-oklch': 'from #101311 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#E5F6C8',
    '--foreground-hsl': '82 72% 87%',
    '--foreground-oklch': 'from #E5F6C8 l c h',
    '--hold-fill': '#84CC16',
    '--hold-fill-hsl': '84 81% 44%',
    '--hold-fill-oklch': 'from #84CC16 l c h',
    '--input': '#243024',
    '--input-hsl': '120 14% 16%',
    '--input-oklch': 'from #243024 l c h',
    '--modal-bg': '#101311',
    '--modal-bg-hsl': '140 9% 7%',
    '--modal-bg-oklch': 'from #101311 l c h',
    '--modal-border': '#243024',
    '--modal-border-hsl': '120 14% 16%',
    '--modal-border-oklch': 'from #243024 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--muted': '#243024',
    '--muted-foreground': '#D9EAC2',
    '--muted-foreground-hsl': '85 49% 84%',
    '--muted-foreground-oklch': 'from #D9EAC2 l c h',
    '--muted-hsl': '120 14% 16%',
    '--muted-oklch': 'from #243024 l c h',
    '--nav-active': '#84CC16',
    '--nav-active-hsl': '84 81% 44%',
    '--nav-active-oklch': 'from #84CC16 l c h',
    '--nav-bg': '#191D1A',
    '--nav-bg-hsl': '135 7% 11%',
    '--nav-bg-oklch': 'from #191D1A l c h',
    '--popover': '#191D1A',
    '--popover-foreground': '#E5F6C8',
    '--popover-foreground-hsl': '82 72% 87%',
    '--popover-foreground-oklch': 'from #E5F6C8 l c h',
    '--popover-hsl': '135 7% 11%',
    '--popover-oklch': 'from #191D1A l c h',
    '--primary': '#84CC16',
    '--primary-foreground': '#101311',
    '--primary-foreground-hsl': '140 9% 7%',
    '--primary-foreground-oklch': 'from #101311 l c h',
    '--primary-hsl': '84 81% 44%',
    '--primary-oklch': 'from #84CC16 l c h',
    '--radius': '14px',
    '--ring': '#84CC16',
    '--ring-hsl': '84 81% 44%',
    '--ring-oklch': 'from #84CC16 l c h',
    '--secondary': '#2D3C2A',
    '--secondary-foreground': '#E5F6C8',
    '--secondary-foreground-hsl': '82 72% 87%',
    '--secondary-foreground-oklch': 'from #E5F6C8 l c h',
    '--secondary-hsl': '110 18% 20%',
    '--secondary-oklch': 'from #2D3C2A l c h',
    '--shadow-card': '0 6px 14px rgba(0, 0, 0, 0.16)',
    '--shadow-card-active': '0 8px 18px color-mix(in srgb, var(--primary) 16%, transparent)',
    '--streak': '#84CC16',
    '--streak-hsl': '84 81% 44%',
    '--streak-oklch': 'from #84CC16 l c h',
    '--success': '#22c55e',
    '--success-foreground': '#101311',
    '--success-foreground-hsl': '140 9% 7%',
    '--success-foreground-oklch': 'from #101311 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(84 81% 44% / 0.15)',
    '--xp': '#84CC16',
    '--xp-bg': '#191D1A',
    '--xp-bg-hsl': '135 7% 11%',
    '--xp-bg-oklch': 'from #191D1A l c h',
    '--xp-hsl': '84 81% 44%',
    '--xp-oklch': 'from #84CC16 l c h'
  }
}
